import React from 'react';

import ReactGA from 'react-ga4';

import { PromotionBanner } from '@app/common/components/PromotionBanner/PromotionBanner';
import { GOOGLE_ANALYTICS_4 } from '@app/common/constants';
import { ILocation } from '@app/common/interfaces';
import { checkAndSetLocalStorage } from '@app/common/setup/utmLocalStorageSetup';
import Footer from '@app/modules/Footer/Footer';

import { THomePageProps } from '.';
import './homepage.scss';
import {
  FeaturedPartners,
  CaseStudiesCarousel,
  KPISection,
  HowItWorks,
  HomePageIntroduction,
  SkillzPoweredGame,
  MonetizeGames,
  RevenueSection,
  SuccessSection,
  TutorialSection,
  ContactSection,
} from './subcomponents';
import { HomePageWelcome } from './subcomponents/HomePageWelcome';

class HomePage extends React.PureComponent<THomePageProps> {
  public componentDidMount(): void {
    let {
      location: { search },
    } = this.props;

    checkAndSetLocalStorage(search);

    ReactGA.event({
      category: GOOGLE_ANALYTICS_4.LANDING_PAGE.CATEGORY,
      action: GOOGLE_ANALYTICS_4.LANDING_PAGE.ACTIONS.VIEW,
    });
  }

  public render(): JSX.Element {
    let { location } = this.props;
    const isDeveloperLandingPageOverhaulEnabled =
      window.appConfig.featureFlags.developerLandingPageOverhaul;

    return (
      <div className="homepage-main-container" data-qa="homepage-main-container">
        {isDeveloperLandingPageOverhaulEnabled ? (
          <>
            <HomePageWelcome />
            <MonetizeGames />
            <RevenueSection />
            <TutorialSection />
            <SuccessSection />
            <ContactSection />
            <Footer />
          </>
        ) : (
          <>
            <HomePageIntroduction location={location as ILocation} />
            <PromotionBanner isFullWidth={true} hideDescription={false} />
            <KPISection />
            <HowItWorks />
            <SkillzPoweredGame />
            <FeaturedPartners />
            <CaseStudiesCarousel />
            <Footer />
          </>
        )}
      </div>
    );
  }
}

export default HomePage;
